// angular imports
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

// local imports
import {  
  AppAvailabilityDto,
  GetCurrentUserAvatarResponseDto,
  GetUserNotificationResponseDto,
  GetTenantsResponseDto,
} from "@core/data/http/dtos";

import { ApplicationConfiguration } from "@core/configuration";
import { ApiConstants, HttpResult, PollyHttpHelper } from "@shared/data/http";

@Injectable({
  providedIn: "root",
})
export class AppDataHttpService {
  constructor(
    private http: HttpClient,
    private applicationConfig: ApplicationConfiguration,
  ) {}

  getApps(): HttpResult<AppAvailabilityDto> {
    let serviceUri = `${this.applicationConfig.applicationUri}/${this.applicationConfig.tenant}/aaa/user/apps`;

    console.log(`GET: ${serviceUri}`);

    return PollyHttpHelper.Invoke("GET", () =>
      this.http.get<AppAvailabilityDto>(serviceUri, {
        headers: ApiConstants.DefaultHeaders,
      }),
    );
  }

  public getTenants(): HttpResult<GetTenantsResponseDto> {
    let serviceUri = `${this.applicationConfig.applicationUri}/core/aaa/users/me/tenants`;

    console.log(`GET: ${serviceUri}`);

    return PollyHttpHelper.Invoke("GET", () =>
      this.http.get<GetTenantsResponseDto>(serviceUri, {
        headers: ApiConstants.DefaultHeaders,
      }),
    );
  }

  public getCurrentUserAvatar(userId: string): HttpResult<GetCurrentUserAvatarResponseDto> {
    let serviceUri = `${this.applicationConfig.applicationUri}/core/aaa/users/${userId}/avatar`;

    console.log(`GET: ${serviceUri}`);

    return PollyHttpHelper.Invoke("GET", () =>
      this.http.get<GetCurrentUserAvatarResponseDto>(serviceUri, {
        headers: ApiConstants.DefaultHeaders,
      }),
    );
  }

  public getUserNotifications(): HttpResult<GetUserNotificationResponseDto> 
  {      
    var result = new HttpResult<GetUserNotificationResponseDto>()
    var dto: GetUserNotificationResponseDto = 
    {
      notifications: []
    }

    result.response = Promise.resolve(dto);

    return result;


    let serviceUri = `${this.applicationConfig.applicationUri}/${this.applicationConfig.tenant}/messaging/notification`;

    console.log(`GET: ${serviceUri}`);

    return PollyHttpHelper.Invoke("GET", () =>
      this.http.get<GetUserNotificationResponseDto>(serviceUri, {
        headers: ApiConstants.DefaultHeaders,
      }),
    );
  }

  public deleteNotification(notificationId: string): HttpResult<Object> {
    let serviceUri = `${this.applicationConfig.applicationUri}/${this.applicationConfig.tenant}/messaging/notification/${notificationId}`;

    console.log(`DELETE: ${serviceUri}`);

    return PollyHttpHelper.Invoke("DELETE", () =>
      this.http.delete<Object>(serviceUri, {
        headers: ApiConstants.DefaultHeaders,
      }),
    );
  }
}